var map = {
	"./icon_calendar.svg": "0645",
	"./icon_video.svg": "5785",
	"./icon_video_active.svg": "80eb",
	"./icon_voice.svg": "cf1a",
	"./icon_voice_active.svg": "c652"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b1c4";